//@config
export default {
  home: {
    help: 'v1/help/{0}',
    helpAttachments: 'v1/help/{0}/attachment',
    helpAttachment: 'v1/help/{0}/attachment/{1}'
  },
}
